/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Templates_SlugInputs */

const cs_social_templates_slug = /** @type {(inputs: Social_Templates_SlugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug`)
};

const en_social_templates_slug = /** @type {(inputs: Social_Templates_SlugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slug`)
};

/**
* | output |
* | --- |
* | "Slug" |
*
* @param {Social_Templates_SlugInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_templates_slug = /** @type {((inputs?: Social_Templates_SlugInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Templates_SlugInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_templates_slug(inputs)
	return cs_social_templates_slug(inputs)
});